import { DialogLike } from "@obg/mat.ui.core";

import { CovidMessageContainer } from "./covid-message.container";

export const COVID_MESSAGE_DIALOG_ID = "covid-message";

export const COVID_MESSAGE_DIALOG: DialogLike<CovidMessageContainer> = {
	dialogId: COVID_MESSAGE_DIALOG_ID,
	dialogComponentType: CovidMessageContainer,
};
